import React from "react";
const ErrorInput = () => {
  return (
    <svg
      className="form-input__error-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="inherit"
      stroke="inherit"
    >
      <path d="M11.5 16.8v-1.2h1v1.2h-1zm0-9.6v7.2h1V7.2h-1z"></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.6a9.6 9.6 0 0 0 9.6-9.6A9.6 9.6 0 0 0 12 2.4 9.6 9.6 0 0 0 2.4 12a9.6 9.6 0 0 0 9.6 9.6zm0-1a8.6 8.6 0 1 0 0-17.2 8.6 8.6 0 0 0 0 17.2z"
      ></path>
    </svg>
  );
};
export default ErrorInput;
